import styled from "styled-components";
import fipayFonts from "../../../../theme";
import { colors } from "../../../../theme/color";

export const PaymentGraphicsContainer = styled.div`
  width: 100%;
  height: 206px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  box-sizing: border-box;
  overflow: hidden;

  @media screen and (max-width: 1024px) {
  }
  @media screen and (max-width: 768px) {
    /* gap: 0px; */
  }
  @media screen and (max-width: 375px) {
    /* gap: 0px; */
  }
  /* @media screen and (max-width: 1024px){

  } */
`;

export const LottiHolder = styled.div`
  width: 130px;
  /* width: 65%; */
  height: 120px;
  box-sizing: border-box;

  @media screen and (max-width: 430px) {
    width: 85px;
    height: 65px;
  }

  @media screen and (max-width: 375px) {
    width: 85px;
    height: 65px;
  }
`;

export const TitleText = styled.div`
  /* width: 152px; */
  height: 20px;

  text-align: left;
  font-size: ${fipayFonts.fipayFonts.body2.size};
  /* font-weight: ${fipayFonts.fipayFonts.fontWeight.bold}; */
  font-weight: 600;
  line-height: 20.29px;
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
  color: ${colors.BLACK};

  /* @media screen and (max-width: 1024px) {
    font-size: ${fipayFonts.fipayFonts.display1.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: left;
  } */
  @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: left;
  }

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.footer2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading2};
    /* text-align: left; */
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.footer2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading2};
    /* text-align: left; */
  }
`;

export const SubtitleTextHolder = styled.div`
  width: 188px;
  height: 30px;
  display: flex;
  /* flex-direction: column; */
  justify-content: center;
  flex-wrap: wrap;
  gap: 2px;
  /* margin-bottom: 20px; */

  @media screen and (max-width: 1440px) {
    /* width: 550px;
    height: 96px; */
  }

  @media screen and (max-width: 1024px) {
    /* width: 400px;
    height: 100%; */
  }

  @media screen and (max-width: 768px) {
    /* display: block;
    width: 550px;
    height: 72px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end; */
  }

  @media screen and (max-width: 430px) {
    width: 128px;
    height: 30px;
    /* display: block;
    width: 327px;
    height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end; */
  }

  @media screen and (max-width: 375px) {
    width: 128px;
    height: 30px;
    /* display: block;
    width: 327px;
    height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end; */
  }
`;

export const SubtitleText = styled.div`
  /* width: 188px;
height: 30px; */
  text-align: center;
  font-size: ${fipayFonts.fipayFonts.footer1.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.footer2};
  color: ${colors.DARK_GRAY};

  @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.footer1.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.footer2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.footer2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    /* line-height: ${fipayFonts.fipayFonts.lineHeight.footer2}; */
    line-height: 12px;
    color: ${colors.DARK_GRAY};
    text-align: left;
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.footer2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    /* line-height: ${fipayFonts.fipayFonts.lineHeight.footer2}; */
    line-height: 12px;
    color: ${colors.DARK_GRAY};
    text-align: left;
  }
`;

export const BoldSubtitleText = styled.div`
  /* width: 188px;
height: 30px; */
  text-align: center;
  font-size: ${fipayFonts.fipayFonts.footer1.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.footer2};
  color: ${colors.DARK_GRAY};

  @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.footer1.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.footer2};
    color: ${colors.DARK_GRAY};
    text-align: center;
  }

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.footer2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    /* line-height: ${fipayFonts.fipayFonts.lineHeight.footer2}; */
    line-height: 12px;
    color: ${colors.DARK_GRAY};
    text-align: center;
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.footer2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    /* line-height: ${fipayFonts.fipayFonts.lineHeight.footer2}; */
    line-height: 12px;
    color: ${colors.DARK_GRAY};
    text-align: center;
  }
`;
